<template>
    <div class="driver-top">
        <div class="header">
            <div class="title">
                我的收藏的騎士
            </div>
            <div class="show" v-show="preprocessing.length" @click.stop="show">
                查看全部
            </div>
        </div>
        <div class="list">
            <driver-item v-for="driver in preprocessing" :driver="driver" :key="driver.id"/>
            <div class="no-driver" v-show="!preprocessing.length">
                您目前無收藏的騎士
                <div class="button" @click.stop="find">
                    尋找騎士
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DriverItem from "./DriverItem";
    import { getDriverTop } from '../../../apis';
    import { mapGetters } from 'vuex';

    export default {
        name: "DriverTop",
        components: {
            'driver-item': DriverItem,
        },
        data() {
            return {
                drivers: []
            }
        },
        computed: {
            preprocessing() {
                let data = [];
                if (this.cart.driver && this.drivers.findIndex(d => d.id == this.cart.driver.id) < 0) {
                    data = data.concat([this.cart.driver])
                }

                data = data.concat(this.drivers);
                data = data.filter((val, index, arr) => {
                    return arr.findIndex(v => v.id == val.id) == index;
                });

                return data.slice(0,3);
            },
            ...mapGetters(['cart']),
        },
        methods: {
            show() {
                this.$router.push({
                    name: 'driversList',
                    params: {
                        type: this.$route.params.type,
                    }
                })
            },
            find() {
                this.$router.push({
                    name: 'ordersList',
                    params: {
                        type: this.$route.params.type,
                    }
                })
            }
        },
        created() {
            getDriverTop(this.$route.params.type).then(res => {
                this.drivers = res.data;
            });
        },
    }
</script>

<style lang="scss" scoped>
    .driver-top {
        padding: 15px;

        .header {
            padding: 15px 10px;
            display: flex;
            justify-content: space-between;
            user-select: none;

            .title {
                color: #000;
                font-size: 18px;
                font-weight: 500;
            }

            .show {
                color: #989898;
                font-size: 14px;
                cursor: pointer;
            }
        }

        .list {
            .no-driver {
                border-radius: 5px;
                background-color: #FAFAFA;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                color: #000000;
                font-size: 14px;
                padding: 25px 15px;
                display: flex;
                justify-content: space-between;

                .button {
                    border-radius: 12px;
                    background-color: #339933;
                    color: #FFFFFF;
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 17px;
                    text-align: right;
                    padding: 4px 10px;
                    cursor: pointer;
                    user-select: none;
                }
            }
        }
    }
</style>